// extracted by mini-css-extract-plugin
export default {"dealsChnager":"DealsChnager_dealsChnager__8ztfs","deal":"DealsChnager_deal__Om62k","name":"DealsChnager_name__vQA0r","total":"DealsChnager_total__-he+W"};